import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from "clsx";
import { cloneElement, useEffect, useRef, useState, } from "react";
import { createPortal } from "react-dom";
export const Tooltip = ({ label, position = "bottom", disabled, className, children, }) => {
    const [newPosition, setNewPosition] = useState("");
    const containerRef = useRef(null);
    const tooltipRef = useRef(null);
    useEffect(() => {
        if (!disabled && !!label) {
            const container = containerRef.current;
            const tooltip = tooltipRef.current;
            const onMouseEnter = () => {
                if (container && tooltip) {
                    setAbsolutePosition(container, tooltip, position, setNewPosition);
                    tooltip === null || tooltip === void 0 ? void 0 : tooltip.classList.add("visible");
                }
            };
            const onMouseLeave = () => tooltip === null || tooltip === void 0 ? void 0 : tooltip.classList.remove("visible");
            container === null || container === void 0 ? void 0 : container.addEventListener("mouseenter", onMouseEnter);
            container === null || container === void 0 ? void 0 : container.addEventListener("mouseleave", onMouseLeave);
            return () => {
                container === null || container === void 0 ? void 0 : container.removeEventListener("mouseenter", onMouseEnter);
                container === null || container === void 0 ? void 0 : container.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [disabled, label, position]);
    return !!label && !disabled ? (_jsxs(_Fragment, { children: [cloneElement(children, { ref: containerRef }), createPortal(_jsx("div", Object.assign({ ref: tooltipRef, className: clsx("tooltip-container", className) }, { children: _jsxs("div", Object.assign({ className: "tooltip" }, { children: [_jsx("div", { className: clsx("arrow", newPosition || position) }), _jsx("div", { children: label })] })) })), document.body)] })) : (children);
};
const setAbsolutePosition = (containerEl, targetEl, position, setNewPosition) => {
    const containerRect = containerEl.getBoundingClientRect();
    const tooltipRect = targetEl.getBoundingClientRect();
    if (position === "bottom" || position === "top") {
        const bottom = Math.floor(containerRect.bottom + 16);
        const top = Math.floor(containerRect.top - tooltipRect.height - 16);
        const leftCenter = Math.floor(containerRect.left + containerRect.width / 2 - tooltipRect.width / 2);
        const reverse = position === "top" ? top < 0 : bottom + tooltipRect.height > window.innerHeight;
        setNewPosition(reverse ? (position === "bottom" ? "top" : "bottom") : "");
        targetEl.style.top = `${position === "bottom" ? (reverse ? top : bottom) : reverse ? bottom : top}px`;
        targetEl.style.left = `${leftCenter}px`;
    }
    else if (position === "right") {
        targetEl.style.top =
            Math.floor(containerRect.top + containerRect.height / 2 - tooltipRect.height / 2) +
                "px";
        targetEl.style.left = Math.floor(containerRect.right + 16) + "px";
    }
    else if (position === "left") {
        targetEl.style.top =
            Math.floor(containerRect.top + containerRect.height / 2 - tooltipRect.height / 2) +
                "px";
        targetEl.style.left = Math.floor(containerRect.left - tooltipRect.width - 16) + "px";
    }
};
